import { Module, GetterTree, ActionTree, MutationTree } from 'vuex';
import http from '@/http'

const state: BusinessAddressState = {
}

const getters: GetterTree<BusinessAddressState, RootState> = {
}

const actions: ActionTree<BusinessAddressState, RootState> = {
  create({ commit }, address) {
    return http.v1.ba.create(address).then(response => {
      if (response.data.data) {
        commit('Business/ADD_ADDRESS', response.data.data, { root: true })
      }
    })
  },
  update({ commit }, address) {
    return http.v1.ba.update(address.object_id, address).then(response => {
      commit('Business/UPDATE_ADDRESS', response.data.data, { root: true })
    })
  },
  delete({ commit }, address) {
    return http.v1.ba.delete(address.object_id).then(response => {
      if (response.status === 204) {
        commit('Business/DELETE_ADDRESS', address.object_id, { root: true })
      }
    })
  },
  billingAddress({ commit }, address) {
    return http.v1.ba.billingAddress(address.object_id, address).then(response => {
      commit('Business/UPDATE_ADDRESS', response.data.data, { root: true })
    })
  },
  postalAddress({ commit }, address) {
    return http.v1.ba.postalAddress(address.object_id, address).then(response => {
      commit('Business/UPDATE_ADDRESS', response.data.data, { root: true })
    })
  },
}

const mutations: MutationTree<BusinessAddressState> = {
}

const business: Module<BusinessAddressState, RootState> = {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}

export default business